<template>
  <div class="lx-home-page">
    <el-row :gutter="20" style="margin-bottom: 20px">
      <el-col :span="12">
        <div class="chart-container">
          <h4 class="chart-title">按新生报到情况统计</h4>
          <chart-one
            style="height: 80%"
            :value="data01"
            :text="'总人数：4470'"
          ></chart-one>
        </div>
      </el-col>
      <el-col :span="12">
        <div class="chart-container">
          <h4 class="chart-title">按新生预报到情况统计</h4>
          <chart-two style="height: 80%" :value="data02"></chart-two>
        </div>
      </el-col>
    </el-row>
    <el-row :gutter="20" style="margin-bottom: 20px">
      <el-col :span="12">
        <div class="chart-container">
          <h4 class="chart-title">按学院报到统计</h4>
          <chart-three style="height: 80%" :value="data03"></chart-three>
        </div>
      </el-col>
      <el-col :span="12">
        <div class="chart-container">
          <h4 class="chart-title">按学院预报到统计</h4>
          <chart-four style="height: 80%" :value="data04"></chart-four>
        </div>
      </el-col>
    </el-row>
    <el-row :gutter="20" style="margin-bottom: 20px">
      <el-col :span="12">
        <div class="chart-container">
          <h4 class="chart-title">按系(院)报到统计</h4>
          <chart-five style="height: 80%" :value="data05"></chart-five>
        </div>
      </el-col>
      <el-col :span="12">
        <div class="chart-container">
          <h4 class="chart-title">按办理事项分类统计</h4>
          <chart-six style="height: 80%" :value="data06"></chart-six>
        </div>
      </el-col>
    </el-row>
    <el-row :gutter="20" style="margin-bottom: 20px">
      <el-col :span="12">
        <div class="chart-container">
          <h4 class="chart-title">已报到男女比例情况</h4>
          <chart-seven style="height: 80%" :value="data07"></chart-seven>
        </div>
      </el-col>
      <el-col :span="12">
        <div class="chart-container">
          <h4 class="chart-title">按民族报到统计</h4>
          <chart-eight style="height: 80%" :value="data08"></chart-eight>
        </div>
      </el-col>
    </el-row>
  </div>
</template>
 
<script>
import chartOne from "./charts/chart01";
import chartTwo from "./charts/chart02";
import chartThree from "./charts/chart03";
import chartFour from "./charts/chart04";
import chartFive from "./charts/chart05";
import chartSix from "./charts/chart06";
import chartSeven from "./charts/chart07";
import chartEight from "./charts/chart08";
export default {
  components: {
    chartOne,
    chartTwo,
    chartThree,
    chartFour,
    chartFive,
    chartSix,
    chartSeven,
    chartEight,
  },
  data() {
    return {
      SUCCESS_CODE: "",
      data01: [
        { name: "未报到", value: 188 },
        { name: "已报到", value: 4282 },
      ],
      data02: [
        { name: "未预报到", value: 874 },
        { name: "已预报到", value: 3596 },
      ],
      data03: {
        学院1: { checked: 3298, nocheck: 137 },
        学院2: { checked: 442, nocheck: 35 },
        学院3: { checked: 42, nocheck: 16 },
      },
      data04: {
        学院1: { checked: 3232, nocheck: 703 },
        学院2: { checked: 321, nocheck: 156 },
        学院3: { checked: 44, nocheck: 14 },
      },
      data05: {
        人文科学系: { checked: 406, nocheck: 15 },
        机械工程系: { checked: 293, nocheck: 14 },
        信息工程系: { checked: 706, nocheck: 23 },
        经济系: { checked: 413, nocheck: 15 },
        管理系: { checked: 602, nocheck: 24 },
        食品工程系: { checked: 463, nocheck: 13 },
        商船系: { checked: 382, nocheck: 13 },
        体育与艺术系: { checked: 533, nocheck: 20 },
      },
      data06: [
        { name: "事项1", value: 3811 },
        { name: "事项2", value: 4282 },
        { name: "事项3", value: 495 },
        { name: "事项4", value: 4279 },
        { name: "事项5", value: 2772 },
      ],
      data07: [
        { name: "男", value: 2109 },
        { name: "女", value: 2173 },
      ],
      data08: [
        { name: "汉族", value: 4135 },
        { name: "蒙古族", value: 9 },
        { name: "回族", value: 31 },
        { name: "苗族", value: 10 },
        { name: "彝族", value: 4 },
        { name: "藏族", value: 10 },
        { name: "布依族", value: 6 },
      ],
    };
  },
  created() {
    this.SUCCESS_CODE = this.$store.state.dic.SUCCESS_CODE;
  },
  mounted() {},
  methods: {},
};
</script>
